export default __webpack_public_path__ + "static/venus-d46b6093fe9f0ac4721fc86d539dc01c.jpg";